import flatpickr from "flatpickr";
import { Controller } from "@hotwired/stimulus"
import { Spanish } from "flatpickr/dist/l10n/es.js"

export default class extends Controller {
  connect() {
    flatpickr(this.element, {
      locale: Spanish,
      enableTime: true,
      noCalendar: true,
      dateFormat: "H:i",
      time_24hr: true,
      allowInput: true,
      clickOpens: true
    })
  }
}
